import React, { PureComponent } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { ForgotPassword, finishForgotPwd, Processing } from 'cloak-file-sdk-web';
import { modalStyles } from '../styles/styles'

const modalStyle = modalStyles.doubleLineModal

class ForgotPasswordPage extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            redirectToLogin: false
        }
    }

    componentDidMount() {
    }

    onClick() {
        this.props.dispatch(finishForgotPwd(true))
        this.setState({ redirectToLogin: true })
    }

    render() {
        const { intl } = this.props
        const { forgot_pwd_status, reset_pwd_status, forgot_pwd_error, reset_pwd_error, forgotPwdInProcess, resetPwdInProcess, mode } = this.props;

        if (this.state.redirectToLogin) {
            return (
                <Navigate to="/cloak/login" />
            )
        }

        const mode1Message = (
            <div>
                {(forgotPwdInProcess && forgot_pwd_status === 200 && mode === '1') && <FormattedMessage id="forgotPwd.verifyMessage" />}
                {(forgotPwdInProcess && forgot_pwd_status === null && forgot_pwd_error === null) && <FormattedMessage id="forgotPwd.sendingResetPasswordEmail" />}
            </div>
        )

        const mode2Message = (
            <div>
                {(resetPwdInProcess && reset_pwd_status === 200 && mode === '2') && <FormattedMessage id="resetPwd.successMessage" />}
                {(resetPwdInProcess && reset_pwd_status === null && reset_pwd_error === null) && <FormattedMessage id="resetPwd.resetting" />}
            </div>
        )

        const mode1Children = (
            <div>
                {
                    (forgotPwdInProcess && forgot_pwd_status === 200) &&
                    <div className="clk-modal-button-div">
                        <button className="clk-modal-button" onClick={() => this.onClick()}>
                            <FormattedMessage id="forgotPwd.ok" />
                        </button>
                    </div>
                }
            </div>
        )

        const mode2Children = (
            <div>
                {
                    (resetPwdInProcess && reset_pwd_status === 200) &&
                    <div className="clk-modal-button-div">
                        <button className="clk-modal-button" onClick={() => this.onClick()}>
                            <FormattedMessage id="forgotPwd.ok" />
                        </button>
                    </div>
                }
            </div>
        )

        console.log("forgotPwdInProcess: " + forgotPwdInProcess)
        console.log("forgot_pwd_status: " + forgot_pwd_status)
        console.log("resetPwdInProcess: " + resetPwdInProcess)
        console.log("reset_pwd_status: " + reset_pwd_status)

        let pageTitle
        if (mode === '1') {
            pageTitle = <FormattedMessage id="forgotPwd.title" />
        } else if (mode === '2') {
            pageTitle = <FormattedMessage id="resetPwd.title" />
        } else {
            pageTitle = <FormattedMessage id="forgotPwd.title" />
        }

        return (
            <div className="clk-primary-console-div">
                <div className="clk-primary-console clk-box-shadow ">
                    <div className="clk-signup-div">
                        <Processing show={forgotPwdInProcess}
                            processing={forgotPwdInProcess && forgot_pwd_status === null && forgot_pwd_error === null}
                            style={modalStyle}
                            message={mode1Message}
                            messageStyle={{ marginTop: 10, color: '#a6a6a6' }}
                            children={mode1Children} />
                        
                        <Processing show={resetPwdInProcess}
                            processing={resetPwdInProcess && reset_pwd_status === null && reset_pwd_error === null}
                            style={modalStyle}
                            message={mode2Message}
                            messageStyle={{ marginTop: 10, color: '#a6a6a6' }}
                            children={mode2Children} />

                        <div className="clk-main-title-div">
                            <div className="clk-main-title-text">
                                {pageTitle}
                            </div>
                        </div>

                        <ForgotPassword emailLabel={intl.formatMessage({ id: 'signUp.email' })}
                            pwdLabel={intl.formatMessage({ id: 'signUp.password' })}
                            cnfrmPwdLabel={intl.formatMessage({ id: 'signUp.confirmPwd' })}
                            actionTitle={pageTitle}
                            mode={mode} />
                    </div>
                </div>
            </div>
        );
    }
}

ForgotPasswordPage.propTypes = {
    mode: PropTypes.string
}

ForgotPasswordPage.defaultProps = {
    mode: '1'
}

const mapStateToProps = state => {
    return {
        forgot_pwd_status: state.reg.forgot_pwd_status,
        reset_pwd_status: state.reg.reset_pwd_status,
        forgot_pwd_error: state.reg.forgot_pwd_error,
        reset_pwd_error: state.reg.reset_pwd_error,
        forgotPwdInProcess: state.reg.forgotPwdInProcess,
        resetPwdInProcess: state.reg.resetPwdInProcess
    }
};


export default connect(mapStateToProps)(injectIntl(ForgotPasswordPage));
